import { MessageBox } from "uiv";

export interface IBootBoxPrompt {
    title: string;
    content?: string,
    callback: (string) => void;
}

//interface IBootboxButton {
//    label?: string;
//    className?: string;
//    callback?: () => any;
//}

//interface IBootboxButtonMap {
//    [key: string]: IBootboxButton | Function;
//}

//** Bootbox options shared by all modal types */
//export interface IBootboxBaseOptions {
//    title?: string | Element;
//    callback?: (result: boolean | string) => any;
//    onEscape?: () => any | boolean;
//    show?: boolean;
//    backdrop?: boolean;
//    closeButton?: boolean;
//    animate?: boolean;
//    className?: string;
//    size?: string;
//    buttons?: IBootboxButtonMap; // complex object where each key is of type BootboxButton
//}

//** Bootbox options available for custom modals */
//interface IBootboxDialogOptions extends IBootboxBaseOptions {
//    message: string | Element;
//}


// ReSharper disable once InconsistentNaming
export class bootbox {

    static confirm(prompt: string, callback: (ok: boolean) => void) {

        MessageBox.confirm({ title: "Confirm", content: prompt})
            .then(() => callback(true))
            .catch(() => callback(false));

    }

    static confirm2(prompt: string): Promise<boolean>{

        return MessageBox.confirm({ title: "Confirm", content: prompt });
    }

    static prompt(settings: IBootBoxPrompt) {
        return MessageBox.prompt({
            title: settings.title,
            backdrop: false,
            //content: settings.content,
                    defaultValue: settings.content? settings.content : ""
                })
            .then(
                (value) => {
                    settings.callback(value);
                });
    }

    static alert(text: string, callback?: () => void) {
        if (!callback)
            callback = () => {};
        MessageBox.alert({ title: "Response", content: text }, callback());

    }

    static alertDialog(title: string, text: string, callback?: () => void): void {
        if (!callback)
            callback = () => { };

        MessageBox.alert({ title: title, content: text, html: true }, callback);

    }

}


// WEBPACK FOOTER //
// ./ClientApp/infrastructure/bootbox-shim.ts